var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useMemo } from 'react';
import { getStrippedEmojiData } from '../Channel/emojiData';
import { useChannelContext } from '../../context/ChannelContext';
var UnMemoizedReactionsList = function (props) {
    var onClick = props.onClick, reaction_counts = props.reaction_counts, reactionOptionsProp = props.reactionOptions, reactions = props.reactions, _a = props.reverse, reverse = _a === void 0 ? false : _a;
    var emojiConfig = useChannelContext().emojiConfig;
    var _b = emojiConfig || {}, defaultMinimalEmojis = _b.defaultMinimalEmojis, Emoji = _b.Emoji, fullEmojiData = _b.emojiData, emojiSetDef = _b.emojiSetDef;
    var emojiData = useMemo(function () { return getStrippedEmojiData(fullEmojiData); }, [fullEmojiData]);
    var reactionOptions = reactionOptionsProp || defaultMinimalEmojis || [];
    var getTotalReactionCount = function () {
        return Object.values(reaction_counts || {}).reduce(function (total, count) { return total + count; }, 0);
    };
    var getOptionForType = function (type) { return reactionOptions.find(function (option) { return option.id === type; }); };
    var getReactionTypes = function () {
        if (!reactions)
            return [];
        var allTypes = new Set(reactions.map(function (_a) {
            var type = _a.type;
            return type;
        }));
        return Array.from(allTypes);
    };
    return (React.createElement("div", { className: "str-chat__reaction-list " + (reverse ? 'str-chat__reaction-list--reverse' : ''), "data-testid": 'reaction-list', onClick: onClick },
        React.createElement("ul", null,
            getReactionTypes().map(function (reactionType) {
                var emojiDefinition = getOptionForType(reactionType);
                return emojiDefinition ? (React.createElement("li", { key: emojiDefinition.id },
                    Emoji && (React.createElement(Emoji
                    // @ts-expect-error
                    , __assign({ 
                        // @ts-expect-error
                        emoji: emojiDefinition }, emojiSetDef, { 
                        // @ts-expect-error
                        data: emojiData, size: 16 }))),
                    "\u00A0")) : null;
            }),
            React.createElement("li", null,
                React.createElement("span", { className: 'str-chat__reaction-list--counter' }, getTotalReactionCount())))));
};
export var ReactionsList = React.memo(UnMemoizedReactionsList);
